import {
  take,
  call,
  put,
  select,
  cancel,
  delay,
  takeLatest
} from "redux-saga/effects";

import { FETCH_SITES } from "./constants";
import SitesApi from "./api";
import * as actions from "./actions";

const mockData = [
  {
    site_id: "6aa88c05-36be-42db-9a41-2f417e59050c",
    site_name: "National College of Physical Education and Sports",
    site_address: "50571 Forster Way",
    site_distance: 62,
    site_location: {
      lat: 26.855047,
      lng: 100.22775
    },
    site_status: "recruiting",
    site_eligiblity:
      "/clinicaltrial/2/diabetes-health-literacy-intervention-improve/eligibility/?language=en"
  },
  {
    site_id: "4be36b69-ad0a-41e5-91d4-3364332e9b64",
    site_name: "University of North Florida",
    site_address: "1 Buena Vista Circle",
    site_distance: 33,
    site_location: {
      lat: 43.4945737,
      lng: 5.8978018
    },
    site_status: "recruiting",
    site_eligiblity:
      "/clinicaltrial/2/diabetes-health-literacy-intervention-improve/eligibility/?language=en"
  },
  {
    site_id: "408bd4a3-5f61-4d5c-8f67-22915b631876",
    site_name: "North Island College",
    site_address: "792 Logan Way",
    site_distance: 34,
    site_location: {
      lat: 20.9275148,
      lng: 106.4081983
    },
    site_status: "not-recruiting",
    site_eligiblity:
      "/clinicaltrial/2/diabetes-health-literacy-intervention-improve/eligibility/?language=en"
  },
  {
    site_id: "12dc03dd-329c-4702-aba2-5b48183fe44a",
    site_name: "International Kazakh-Turkish University",
    site_address: "0 Rockefeller Lane",
    site_distance: 16,
    site_location: {
      lat: 32.837949,
      lng: 35.399996
    },
    site_status: "recruiting",
    site_eligiblity:
      "/clinicaltrial/2/diabetes-health-literacy-intervention-improve/eligibility/?language=en"
  },
  {
    site_id: "fa1aaec3-145c-46a9-ac54-12028f42e285",
    site_name: "Union University",
    site_address: "03018 Brentwood Plaza",
    site_distance: 3,
    site_location: {
      lat: 9.6365101,
      lng: 123.8536209
    },
    site_status: "not-recruiting",
    site_eligiblity:
      "/clinicaltrial/2/diabetes-health-literacy-intervention-improve/eligibility/?language=en"
  },
  {
    site_id: "4ab3f9ad-a697-4cf4-b764-fe9735ffe705",
    site_name:
      "Fachhochschule Biberach, Hochschule für Bauwesen und Wirtschaft",
    site_address: "13 Pawling Pass",
    site_distance: 14,
    site_location: {
      lat: 11.5825677,
      lng: 108.9912066
    },
    site_status: "recruiting",
    site_eligiblity:
      "/clinicaltrial/2/diabetes-health-literacy-intervention-improve/eligibility/?language=en"
  },
  {
    site_id: "3595aed3-3599-4fbe-b461-00926150f005",
    site_name: "Bells University of Technology",
    site_address: "63288 Golf View Junction",
    site_distance: 77,
    site_location: {
      lat: 22.691253,
      lng: 114.346251
    },
    site_status: "recruiting",
    site_eligiblity:
      "/clinicaltrial/2/diabetes-health-literacy-intervention-improve/eligibility/?language=en"
  },
  {
    site_id: "7bdec0df-5ffc-4923-9bd5-6f603327a643",
    site_name: "Sekolah Tinggi Akuntansi Negara (STAN)",
    site_address: "3 Garrison Park",
    site_distance: 64,
    site_location: {
      lat: 40.752984,
      lng: -73.9145038
    },
    site_status: "not-recruiting",
    site_eligiblity:
      "/clinicaltrial/2/diabetes-health-literacy-intervention-improve/eligibility/?language=en"
    },
    {
      site_id: "a3ca8d90-4176-4f1f-aa66-6a808c606d65",
      site_name: "Community College of Denver",
      site_address: "82 Cordelia Parkway",
      site_distance: 86,
      site_location: {
        lat: 13.559532,
        lng: 123.2715608
      },
      site_status: "recruiting",
      site_eligiblity:
        "/clinicaltrial/2/diabetes-health-literacy-intervention-improve/eligibility/?language=en"  
  }
];



export function* fetchSitesAPI(action) {
  const { trial_id, language, lat, lng, radius, country, place } = action;
  try {
    yield put(actions.fetchSitesRequest());
    const [promise, cancelRequest] = yield SitesApi.getSites({
      trial_id,
      language,
      lat,
      lng,
      radius,
      country,
      place
    });
    const { count,eligibility, results: data } = yield promise;
    yield put(
      actions.fetchSitesSuccess({
        data: data
      })
    );
  } catch (error) {
    // const { sites: data } = yield Promise.resolve({
    //   sites: mockData
    // });
    // yield put(
    //   actions.fetchSitesSuccess({
    //     data: data
    //   })
    // );
    yield put(actions.fetchSitesError(error.message));
  } finally {
    //    if (yield cancelled()) {
    //      c.abort();
    //    }
  }
}

export function* siteFetchWatcher() {
  yield takeLatest(FETCH_SITES, fetchSitesAPI);
}

export default [siteFetchWatcher()];
